<template>
  <!--==================
    component shows all unpublished and inactive packages (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <nav>
      <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link active"
          id="nav-unpublished-tab"
          data-toggle="tab"
          href="#nav-unpublished"
          role="tab"
          aria-controls="nav-unpublished"
          aria-selected="true"
          data-selector="unpublished"
        >
          Unpublished
        </a>
        <a
          class="nav-item nav-link"
          id="nav-inactive-tab"
          data-toggle="tab"
          href="#nav-inactive"
          role="tab"
          aria-controls="nav-inactive"
          aria-selected="false"
          data-selector="inactive"
        >
          Inactive
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <!-- unpublished packages -->
      <div class="tab-pane fade show active" id="nav-unpublished" role="tabpanel" aria-labelledby="nav-unpublished-tab">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-nowrap card-table">
              <thead class="text-primary">
                <tr>
                  <th>#</th>
                  <th>TOUR ID</th>
                  <th>TOUR DAYS</th>
                  <th>TOUR TITLE</th>
                  <th>OPERATOR</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tour, index) in unpublished"
                  :key="tour.id"
                  :data-position="tour.position"
                  :data-id="tour.id"
                >
                  <td :id="'row-' + tour.id">{{ index + 1 }}</td>
                  <td class="font-weight-bold">{{ tour.id }}</td>
                  <td class="font-weight-bold">{{ tour.noOfDay }}</td>
                  <td class="font-weight-bold">{{ tour.title }}</td>
                  <td>
                    <a class="d-block p-3" :href="operatorUrl + tour.operator.id" target="_blank">{{
                      tour.operator.companyName
                    }}</a>
                  </td>
                  <td class="text-right">
                    <button
                      @click="publishStatus($event)"
                      class="btn btn-sm btn-success mr-2"
                      :data-id="tour.id"
                      :data-index="index"
                    >
                      Publish
                    </button>
                    <button @click="edit($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="tour.id">
                      Edit
                    </button>
                    <button
                      @click="remove($event)"
                      class="btn btn-sm btn-danger ml-2"
                      :data-id="tour.id"
                      :data-index="index"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- inactive packages -->
      <div class="tab-pane fade" id="nav-inactive" role="tabpanel" aria-labelledby="nav-inactive-tab">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-nowrap card-table">
              <thead class="text-primary">
                <tr>
                  <th>#</th>
                  <th>TOUR ID</th>
                  <th>TOUR DAYS</th>
                  <th>TOUR TITLE</th>
                  <th>OPERATOR</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tour, index) in inactive" :key="tour.id" :data-position="tour.position" :data-id="tour.id">
                  <td :id="'row-' + tour.id">{{ index + 1 }}</td>
                  <td class="font-weight-bold">{{ tour.id }}</td>
                  <td class="font-weight-bold">{{ tour.noOfDay }}</td>
                  <td class="font-weight-bold">{{ tour.title }}</td>
                  <td>
                    <a class="d-block p-3" :href="operatorUrl + tour.operator.id" target="_blank">{{
                      tour.operator.companyName
                    }}</a>
                  </td>
                  <td class="text-right">
                    <button
                      @click="activeStatus($event)"
                      class="btn btn-sm btn-success mr-2"
                      :data-id="tour.id"
                      :data-index="index"
                    >
                      Active
                    </button>
                    <button @click="edit($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="tour.id">
                      Edit
                    </button>
                    <button
                      @click="remove($event)"
                      class="btn btn-sm btn-danger ml-2"
                      :data-id="tour.id"
                      :data-index="index"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Package",

  computed: {
    ...mapGetters(["unpublishedPackages", "inactivePackages"]),

    unpublished() {
      let sortedTours = this.unpublishedPackages;

      // sort tours by last updated date
      sortedTours.sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt));

      return sortedTours;
    },

    inactive() {
      return this.inactivePackages;
    },

    operatorUrl() {
      return process.env.VUE_APP_OPERATOR_URL;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchUnpublishedPackages();
      await this.fetchInactivePackages();

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "fetchUnpublishedPackages",
      "fetchInactivePackages",
      "updatePackageStatus",
      "publishPackage",
      "deletePackage",
      "hideBarLoading",
    ]),

    async activeStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.updatePackageStatus({ id, status: 1 });
      this.fetchInactivePackages();
    },

    async publishStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.publishPackage({ id, publish: true });
      this.fetchUnpublishedPackages();
    },

    edit(e) {
      let id = e.target.getAttribute("data-id");

      window.open("/dashboard/tour/edit/" + id, "_blank");
    },

    remove(e) {
      let id = e.target.getAttribute("data-id");
      let selector = $(".nav-item.nav-link.active").attr("data-selector");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this package?",
        buttons: {
          confirm: async () => {
            await dP.deletePackage(id);

            if (selector == "unpublished") {
              dP.fetchUnpublishedPackages();
            } else {
              dP.fetchInactivePackages();
            }
          },
          cancel: () => {},
        },
      });
    },
  },
};
</script>
